<template>
  <v-app
    v-cloak
    :class="{
      'no-scroll':
        $route.path.includes('/your-parking/guest') ||
        $route.path.includes('/your-parking/cyberport-guest'),
    }"
  >
    <Confirm class="confirm-dialog" />
    <Loader />
    <NotificationPopup />
    <Downloading />
    <router-view />
  </v-app>
</template>

<script>
import Loader from "@/components/core/Loader";
// import Vuetify from "vuetify";
import "@/scss/main.scss";

export default {
  name: "App",
  // vuetify: new Vuetify(),
  components: {
    Loader,
    NotificationPopup: () => import("@/components/core/NotificationPopup"),
    Downloading: () => import("@/components/core/Downloading"),
  },
  computed: {
    isAuthorized() {
      return this.$store.getters["app/authorized"];
    },
  },
  watch: {
    isAuthorized(val) {
      if (val) {
        this.$store.dispatch("app/getPlacesInfo")
      }
    },
  },
  beforeMount() {
    if (this.isAuthorized) {
      this.$store.dispatch("app/getPlacesInfo")
    }
  },
  mounted() {
    this.$moment.locale("en-AU");
    this.$moment.updateLocale(this.$moment.locale(), { invalidDate: "" });
  },
};
</script>
